import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Curso.types';
import * as Cursos from './Curso.types';
import { ICurso, IParticipante, IEstadistica} from './Curso.lib';
import { Resultado } from '@/__env/lib/Cursos/Resultado';



export class Curso extends ICurso
{

    public static async create( id: number ): Promise<Curso>
    {
        let o = new Curso();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/cursos';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Curso>; Error?: boolean; }>
    {

        let a: Array<Curso> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/cursos` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Curso( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            console.log( 'a', js );

            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async Iniciar(): Promise<boolean>
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();

                req.path = `/cursos/${this.Id}/respuestas`;
                if ( await req.post() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async ModificarEstado( estado: Cursos.Estados ): Promise<boolean>
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.params.estado = estado.Id;
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async cargarParticipantes(): Promise<boolean>
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.params.curso = this.Id;
                req.path = `${this.Route}/participantes`;
                if ( await req.get() )
                {
                    this.Participantes = req.data.map( ( x: any ) => new Participante( x ) );
                    console.log( this.Participantes );
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async cargarEstadistica(): Promise<boolean>
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.params.curso = this.Id;
                req.path = `${this.Route}/estadistica`;
                if ( await req.get() )
                {
                    this.Estadistica = new IEstadistica( req.data );
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}


export class Participante extends IParticipante
{
    public async cargarResultado(): Promise<boolean>
    {
        try
        {
            if ( this.Existe )
            {
                this.Resultado = await Resultado.create( this.Curso, this.Id );
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}